<template>
  <div class="parcel">
    <div class="message" :style="{ height: screenheight }">
      <div
        class="wow animate__zoomIn"
        data-wow-duration="1s"
        data-wow-delay="0.5s"
      >
        <h3>快速、高效、安全、吉时达物流</h3>
        <p>Fast, efficient, safe and auspicious logistics</p>
      </div>
    </div>
    <div class="parcel-tracking">
      <h3>查快递</h3>
      <div class="divider"></div>
      <div class="input-div">
        <textarea
          rows="3"
          v-model="detailCode"
          ref="myInput"
          placeholder="请输入运单号或包裹号，多行单用逗号，空格或换行符隔开（最多可同时查询20条）"
        ></textarea>
        <div class="search" @click="parcelSearch">
          查询<img
            src="../assets/img/parcel/parcelTracking.png"
            mode="widthFix"
          />
        </div>
      </div>
    </div>
    <div class="parcel-info">
      <div v-loading="isLoadingDialog">
        <div v-if="detailData && detailData.length">
          <div
            :class="
              index % 2 === 0
                ? 'steps-wrap wow animate__fadeInLeft'
                : 'steps-wrap wow animate__fadeInRight'
            "
            data-wow-duration="1s"
            data-wow-delay="0.5s"
            v-for="(item, index) in detailData"
            :key="index"
          >
            <h4>运单号：{{ addSpaceEveryFourChars(item.waybillCode) }}</h4>
            <div v-if="item.trackDetails.length != 0">
              <div class="address" :style="getStyle(index)">
                <div class="address-name">
                  <div>
                    <h6>{{ item.departurePlace }}</h6>
                    <p>始发地</p>
                  </div>
                  <img
                    src="../assets/img/parcel/LogisticsImg.png"
                    mode="widthFix"
                  />
                  <div>
                    <h6>{{ item.receivingPlace }}</h6>
                    <p>目的地</p>
                  </div>
                </div>
                <div
                  v-for="(info, i) in item.trackDetails"
                  :key="i"
                  class="address-steps"
                >
                  <div class="time">
                    <h6>{{ getTime(info.scanTime, "data") }}</h6>
                    <p>{{ getTime(info.scanTime, "hour") }}</p>
                  </div>
                  <div class="image">
                    <div>
                      <img
                        class="img1"
                        v-if="i == item.trackDetails.length - 1"
                        src="../assets/img/parcel/packageIcon.png"
                        mode="widthFix"
                      />
                      <img
                        class="img2"
                        v-else-if="i == 0"
                        src="../assets/img/parcel/successIcon.png"
                        mode="widthFix"
                      />
                      <div v-else class="logisticsImg"></div>
                    </div>
                    <div
                      v-if="i != item.trackDetails.length - 1"
                      class="logisticsItem"
                    ></div>
                  </div>
                  <div class="status">
                    <h5 :class="i == 0 ? 'bgBlickH' : ''">
                      {{ info.scanStatus }}
                    </h5>
                    <p :class="i == 0 ? 'bgBlickP' : ''">
                      {{ info.expressDesc }}
                    </p>
                  </div>
                </div>
                <!-- <div class="address-steps">
                <el-steps
                  class="steps"
                  direction="vertical"
                  :active="0"
                  :space="50"
                  finish-status="success"
                >
                  <el-step
                    v-for="(info, i) in item.trackDetails"
                    :key="i"
                    :title="info.scanStatus"
                  >
                    <i
                      v-if="i == item.trackDetails.length - 1"
                      class="build"
                      slot="icon"
                    ></i>
                    <i v-else class="bidding" slot="icon"></i>
                    <div slot="description">
                      <div class="time">
                        <h6>{{ getTime(info.scanTime, "data") }}</h6>
                        <p>{{ getTime(info.scanTime, "hour") }}</p>
                      </div>
                      <p></p>
                    </div>
                  </el-step>
                </el-steps>
              </div> -->
              </div>
              <div class="collapse" @click="showInfo(index)">
                <p>
                  {{ thisIndex.indexOf(index) != -1 ? "收起内容" : "展开内容" }}
                </p>
                <img
                  v-if="thisIndex.indexOf(index) != -1"
                  src="../assets/img/parcel/arrowUp.png"
                  mode="widthFix"
                />
                <img
                  v-else
                  src="../assets/img/parcel/arrowDown.png"
                  mode="widthFix"
                />
                <!-- <i
                :class="
                  thisIndex.indexOf(index) != -1
                    ? 'el-icon-d-arrow-left'
                    : 'el-icon-d-arrow-right'
                "
                :style="{
                  color: thisIndex.indexOf(index) != -1 ? '#0195ff' : '#999999',
                }"
              ></i> -->
              </div>
            </div>
            <div
              v-else
              class="noList wow animate__pulse"
              data-wow-duration="1s"
              data-wow-delay="1s"
            >
              <img src="../assets/img/parcel/noMessage.png" alt="" />
              <p>暂无物流信息</p>
            </div>
          </div>
        </div>
        <div
          v-else
          style="margin-top: 100px"
          class="noList wow animate__pulse"
          data-wow-duration="1s"
          data-wow-delay="1s"
        >
          <img src="../assets/img/parcel/noMessage.png" alt="" />
          <p>请输入运单号</p>
        </div>
      </div>
    </div>

    <!--滑动图片弹窗验证-->
    <el-dialog
      title="拖动滑块还原图片"
      :visible.sync="isVerificationShow"
      align-center
      :lock-scroll="false"
      :close-on-click-modal="false"
      width="350px"
    >
      <slide-verify
        ref="slideblock"
        :imgs="puzzleImgList"
        @again="onAgain"
        @success="onSuccess"
        @fail="onFail"
        slider-text="向右滑动"
        :accuracy="5"
      ></slide-verify>
      <div>{{ msg }}</div>
    </el-dialog>
  </div>
</template>

<script>
import { WOW } from "wowjs";
export default {
  data() {
    return {
      detailCode: "",
      isLoadingDialog: false,
      isVerificationShow: false,
      detailData: [], // 物流详情
      waybillList: [], // 单号
      screenheight: document.documentElement.clientHeight + "px",
      puzzleImgList: [
        require("../assets/img/banner/banner1.png"),
        require("../assets/img/banner/banner2.png"),
      ],
      msg: "",
      thisIndex: [],
    };
  },
  mounted() {
    var wow = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: true, // 在移动设备上触发动画（默认为true）
      live: true, // 对异步加载的内容进行操作（默认值为true）
      callback: function (box) {
        // 每次启动动画时都会触发回调,传入的参数是正在设置动画的DOM节点
      },
      scrollContainer: null, // 可选滚动容器选择器，否则使用window，
      resetAnimation: true, // 结束时重置动画（默认为true）
    });
    wow.init();

    window.scrollTo(0, 0); // 置顶
    this.screenheight =
      Math.round((document.documentElement.clientWidth * 401) / 1440) + "px";

    // 聚焦
    this.$nextTick(() => {
      this.$refs.myInput.focus();
    });
    // if (this.$refs.myInput) {
    //   setTimeout(() => {
    //     this.$refs.myInput.focus();
    //   }, 0);
    // }
  },

  created() {
    window.addEventListener("resize", () => {
      this.screenheight =
        Math.round((document.documentElement.clientWidth * 401) / 1440) + "px";
    });
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        if (val.hash && val.hash != "#ele1") {
          this.$router.push("/" + val.hash);
        }
      },
      // 深度观察监听
      deep: true,
    },
  },
  methods: {
    parcelSearch() {

      if (this.detailCode == "") {
        return this.$message({
          customClass: "elmessageTop",
          type: "error",
          message: "请先输入物流编号",
          duration: 1000,
        });
      }

      const uniqueNonEmptySet = this.splitByCommaOrOrSpace();
      const validatedWaybillList = this.validateWaybillList(uniqueNonEmptySet);

      if (validatedWaybillList.length === uniqueNonEmptySet.length) {
        this.waybillList = validatedWaybillList;
        this.isVerificationShow = true;
        this.detailData = [];
      } else {
        const errList = uniqueNonEmptySet.filter(
          (item) => !validatedWaybillList.includes(item)
        );
        let errMsg = errList.join(", ") + "，请仔细检查运单号";
        return this.$confirm(errMsg, "运单号有误", {
          confirmButtonText: "确定",
          showCancelButton: false, //是否显示取消按钮
          closeOnClickModal: false, //是否可以通过点击空白处关闭弹窗
          type: "warning",
        });
      }

      this.$nextTick(() => {
        this.$refs.slideblock.reset();
      });
    },
    splitByCommaOrOrSpace() {
      const regex = /[\u3000，\s,]+/g; // \u3000 是全角空格，这里也加上了以支持可能的宽空格
      const list = this.detailCode.split(regex);
      const uniqueNonEmptySet = [
        ...new Set(list.filter((item) => item !== "")),
      ];
      return uniqueNonEmptySet;
    },
    validateWaybillList(waybillList) {
      return waybillList.filter(
        (item) => item.length >= 15 && item.startsWith("JS")
      );
    },
    searchList() {
      this.isLoadingDialog = true;
      let params = { waybillCode: this.waybillList };
      this.$api
        .parcelList(params)
        .then((res) => {
          let request = res.data;
          if (request.code == 0) {
            this.detailData = request.data;
          } else {
            let errMsg = request.msg + "，请仔细检查运单号";
            this.$confirm(errMsg, "运单号有误", {
              confirmButtonText: "确定",
              showCancelButton: false, //是否显示取消按钮
              closeOnClickModal: false, //是否可以通过点击空白处关闭弹窗
              type: "warning",
            });
            // this.$message({
            //   customClass: "elmessageTop",
            //   type: "error",
            //   message: res.data.msg,
            //   duration: 1000,
            // });
          }
        })
        .catch(() => {
          this.detailData = [];
        })
        .finally(() => {
          this.isLoadingDialog = false;
        });
    },
    onSuccess(times) {
      this.msg = "";
      this.$message({
        customClass: "elmessageTop",
        message: `验证通过，耗时${(times / 1000).toFixed(1)}s，订单开始查询`,
        type: "success",
        duration: 1000,
      });
      this.isVerificationShow = false;
      setTimeout(() => {
        this.searchList();
      }, 300);
    },
    onFail() {
      this.msg = "验证不通过，请重新尝试";
    },
    onAgain() {
      this.msg = "检测到非人为操作";
      // 刷新
      this.$refs.slideblock.reset();
    },
    addSpaceEveryFourChars(str) {
      let result = "";
      for (let i = 0; i < str.length; i++) {
        result += str[i];
        // 当索引是4的倍数且不是字符串的最后一个字符时，添加空格
        if ((i + 1) % 4 === 0 && i !== str.length - 1) {
          result += " ";
        }
      }
      return result;
    },
    getTime(value, type) {
      let time = "";
      if (type == "data") {
        time = value.match(/^\S*/)[0];
      } else if (type == "hour") {
        time = value.match(/\s(.*)/)[1];
      }
      return time;
    },
    showInfo(index) {
      if (this.thisIndex.indexOf(index) == -1) {
        this.thisIndex.push(index);
      } else {
        this.thisIndex = this.thisIndex.filter((item) => item != index);
      }
    },
    getStyle(index) {
      return {
        height: this.thisIndex.indexOf(index) != -1 ? "auto" : "140px",
        overflow: "hidden",
      };
    },
  },
};
</script>
<style>
.elmessageTop {
  top: 180px !important;
}
</style>
<style lang="scss" scoped>
.parcel {
  min-width: 1000px;
  background-color: #f7f7f7;
  .message {
    width: 100%;
    height: 100%; /* 如果高度未知或想要根据内容调整 */
    background: url(../assets/img/parcel/parcelBanner.png) no-repeat center;
    background-size: cover;
    background-position: center;
    color: #fff;
    box-sizing: border-box;
    position: relative;
    div {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%); /* 使用transform来居中元素 */
      transition: transform 0.5s ease;
      text-align: center;
      overflow: hidden;
      h3 {
        font-size: 48px;
        font-weight: 600;
        color: #fff;
        margin: 0;
      }
      p {
        font-size: 20px;
        font-weight: 400;
        color: #fff;
      }
    }
  }

  .parcel-tracking {
    margin: 80px 12% 16px;
    h3 {
      font-size: 28px;
      color: #1d2129;
      line-height: 50px;
      margin: 0;
    }

    .divider {
      width: 55px;
      height: 6px;
      background-color: #084fff;
      margin-bottom: 22px;
    }

    .input-div {
      width: 100%;
      font-size: 12px;
      position: relative;
      textarea {
        width: 100%;
        height: 120px;
        border-radius: 4px;
        background-color: #ffffff;
        resize: none;
        border: none;
        color: #333333;
        padding: 12px;
        box-sizing: border-box;
      }
      .search {
        width: 64px;
        height: 26px;
        background-color: #1d2129;
        border-radius: 2px;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        bottom: 12px;
        right: 12px;

        img {
          width: 12px;
          margin-left: 4px;
        }
      }
    }
  }

  .parcel-info {
    margin: 0 12%;
    padding-bottom: 80px;
    .steps-wrap {
      background-color: #fff;
      border-radius: 4px;
      margin-bottom: 16px;
      h4 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 18px;
        color: #1d2129;
        text-align: left;
        font-style: normal;
        padding: 16px 0;
        margin: 0 20px;
        border-bottom: 1px solid #f2f3f5;
      }
      .address {
        margin: 22px 8% 0;
        box-sizing: border-box;
        &-name {
          display: flex;
          align-items: center;
          justify-content: start;
          margin-bottom: 38px;
          div {
            text-align: center;
            h6 {
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 18px;
              color: #1d2129;
              margin: 0;
              font-style: normal;
            }
            p {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: #86909c;
              margin: 0;
              line-height: 30px;
              font-style: normal;
            }
          }

          img {
            width: 110px;
            margin: 0 51px;
          }
        }
        &-steps {
          margin-left: 80px;
          display: flex;
          align-items: start;
          justify-content: left;
          position: relative;
          .time {
            text-align: left;
            position: absolute;
            top: -12px;
            left: -80px;
            h6 {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 16px;
              color: #858ba2;
              line-height: 22px;
              text-align: left;
              font-style: normal;
              margin: 0;
            }
          }
          .image {
            width: 69px;
            height: 75px;
            text-align: center;
            position: relative;
            .img1 {
              width: 15px;
            }
            .img2 {
              width: 20px;
              position: absolute;
              top: 0;
              right: 24px;
            }
            .logisticsImg {
              width: 7px;
              height: 7px;
              border-radius: 50%;
              background-color: #d2d9e9;
              margin: 0 auto;
            }
            .logisticsItem {
              margin: 0 auto;
              width: 1px;
              height: 100%;
              background-color: #eef0f6;
            }
          }
          .status {
            color: #aeb4c7;
            position: absolute;
            top: -12px;
            left: 80px;
            h5 {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 16px;
              text-align: left;
              font-style: normal;
              margin: 0;
            }
            p {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              line-height: 20px;
              text-align: left;
              font-style: normal;
              margin: 0;
            }
            .bgBlickP {
              color: #86909c;
            }
            .bgBlickH {
              color: #1d2129;
            }
          }
          p {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #aeb4c7;
            font-style: normal;
            margin: 0;
          }
        }
        // &-steps {
        //   margin-left: 80px;
        //   .build {
        //     width: 15px;
        //     height: 13px;
        //     background-size: 100% 100%;
        //     background-image: url("../assets/img/parcel/packageIcon.png");
        //   }
        //   .bidding {
        //     // width: 14px;
        //     // height: 14px;
        //     // background-color: #D2D9E9;
        //     // border-radius: 50%;
        //   }
        //   .time {

        //     position: absolute;
        //     left: -100px;
        //     top: -5px;
        //     text-align: left;
        //     h6 {
        //       font-family: PingFangSC, PingFang SC;
        //       font-weight: 400;
        //       font-size: 16px;
        //       color: #858ba2;
        //       line-height: 22px;
        //       text-align: left;
        //       font-style: normal;
        //       margin: 0;
        //     }
        //     p {
        //       margin: 0;
        //       font-family: PingFangSC, PingFang SC;
        //       font-weight: 400;
        //       font-size: 14px;
        //       color: #86909c;
        //       line-height: 20px;
        //       text-align: left;
        //       font-style: normal;
        //     }
        //   }
        //   .bgBlickP {
        //     color: #86909c;
        //   }
        //   .bgBlickH {
        //     color: #1d2129;
        //   }
        //   p {
        //     font-family: PingFangSC, PingFang SC;
        //     font-weight: 400;
        //     font-size: 14px;
        //     color: #aeb4c7;
        //     font-style: normal;
        //     margin: 0;
        //   }
        // }
      }
      .collapse {
        height: 35px;
        display: flex;
        justify-content: center;
        align-items: start;
        p {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #86909c;
          font-style: normal;
          margin: 0;
        }
        img {
          width: 18px;
          margin-left: 8px;
        }
      }
    }
    .noList {
      text-align: center;
      margin: 20px auto 0;
      padding-bottom: 20px;
      img {
        width: 168px;
        margin-bottom: 14px;
      }
      p {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #86909c;
        font-style: normal;
      }
    }
    p {
      display: block;
      margin-bottom: 5px;
    }
  }
}

::v-deep .el-step__icon-inner[class*="el-icon"]:not(.is-status) {
  font-size: 16px;
}
::v-deep .el-dialog__body {
  padding: 0 20px 20px;
}
::v-deep .el-step.is-vertical .el-step__head {
  min-height: 70px;
}
::v-deep .el-step__title.is-finish {
  color: #1d2129;
}

.steps {
  //process状态自定义图片
  ::v-deep .el-step__head.is-process {
    position: relative;
    height: 24px;

    .el-step__icon.is-text {
      border: none; //不显示圆圈
      position: absolute;
      top: 0;
      left: 0;
      width: 26px;
      height: 26px;
      background-color: #fff;
      background-size: 100% 100%;
      background-image: url("../assets/img/parcel/successIcon.png");
    }

    .el-step__icon-inner {
      display: none; //不显示内部数字
    }
  }
}
</style>
